import { WidgetPersonalFeedPreviewPropertiesType } from './types';

/** name of the widgetType in the widget personal feed preview */
export const WIDGET_PERSONAL_FEED_PREVIEW_TYPE = 'personal-feed-preview';

export const SCOPE = 'widget-personal-feed';

/** The default properties for the widget personal feed preview */
export const WIDGET_PERSONAL_FEED_PREVIEW_DEFAULT_PROPERTIES: WidgetPersonalFeedPreviewPropertiesType = {
    siteId: undefined,
    maxNumber: 5,
    displayHeader: true,
    fields: ['contextual_banner', 'title', 'excerpt', 'reactions'],
    viewMode: 'list',
    viewModeVariant: 'grouped',
};

export const WIDGET_PERSONAL_FEED_PREVIEW_SETTINGS_ITEM_NUMBERS = {
    minimum: 1,
    default: 5,
    maximum: 100,
};
